import { snakeCase } from "lodash";

const getTestId = ({ label, index }: { label?: string; index?: number }) => {
  return index || index === 0
    ? `${snakeCase(label)}-${index}`
    : snakeCase(label);
};

export default getTestId;
